import { useCallback, useRef, useState } from 'react';

import {
    BorderIcon,
    FotosContainer,
    FotosRow,
    ImageSizeContainer,
    ImageText,
    Img,
    InputImage,
    PlusImage
} from './styles';

import { deleteProductImage, getProductInfo, postImage } from '../../api';


import { CameraAltOutlined, Close } from '@mui/icons-material';
import { IMAGES_ACTION_TYPES, useProduto } from '../../useProduto';

export const FotosComponent = ({ addToast }) => {
    const [{ images = [], idProduto }, dispatch] = useProduto();

    const imageInputRef = useRef();

    const handleDelete = async ({ idProdutoImagem }) => {
        try {
            await deleteProductImage({ idProduto, idProdutoImagem });
            await updateImagesState();

            addToast({
                text: 'imagem excluída com sucesso',
                theme: 'success'
            });
        } catch (error) {
            const [e] = error;
            addToast({
                text: e.message,
                theme: 'error'
            });
        }
    };

    const Foto = useCallback(({ item }) => {
        const [loaded, setLoaded] = useState(false);
        const [failed, setFailed] = useState(false);

        const imageUrl = item.ds_imagem_url;

        if (!imageUrl || failed) {
            return null;
        }

        return (
            <ImageSizeContainer>
                <Img
                    alt="imagem produto"
                    src={imageUrl}
                    onLoad={() => setLoaded(true)}
                    onError={() => setFailed(true)}
                    style={{ display: loaded ? 'block' : 'none' }}
                />
                {loaded && (
                    <BorderIcon
                        type="button"
                        onClick={() =>
                            handleDelete({
                                idProdutoImagem: item.id_produto_imagem
                            })
                        }
                    >
                        <Close 
                            sx={{
                                fontSize: 18,
                                color: 'black'
                            }} 
                        />
                    </BorderIcon>
                )}
            </ImageSizeContainer>
        );
    }, []);

    const validateImage = useCallback(
        (file) => {
            const type = file.type.split('/').pop().toLowerCase();

            if (
                type !== 'jpeg' &&
                type !== 'jpg' &&
                type !== 'png' &&
                type !== 'gif'
            ) {
                addToast({
                    text: 'O tipo da imagem deve ser jpeg, jpg, png ou gif.',
                    more: 'OK',
                    theme: 'error'
                });

                return false;
            }
            if (file.size > 1024000) {
                addToast({
                    text: 'O tamanho da imagem deve possuir no máximo 1 MB.',
                    more: 'OK',
                    theme: 'error'
                });
                return false;
            }

            return true;
        },
        [addToast]
    );

    const toBase64 = (file) => {
        const changeFile = new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });

        return changeFile;
    };

    const updateImagesState = async () => {
        const { lsProdutoImagem } = await getProductInfo({ idProduto });

        const checkArr = lsProdutoImagem || [];

        dispatch({
            type: IMAGES_ACTION_TYPES.UPDATE_IMAGES,
            payload: [...checkArr]
        });

        return lsProdutoImagem;
    };

    const onChangeImage = useCallback(
        async ({ currentTarget }) => {
            try {
                const { files } = currentTarget;
                const [file] = files;

                const isValid = validateImage(file);

                if (!isValid) return;

                const newFormData = new FormData();

                newFormData.append('image', file);

                await postImage({
                    form: newFormData,
                    idProduto
                });

                await updateImagesState();

                addToast({
                    text: 'Imagem adicionada com sucesso',
                    theme: 'success'
                });
            } catch (error) {
                const [e] = error;
                addToast({
                    text: e.message,
                    theme: 'error'
                });
            }
            if (imageInputRef.current) {
                imageInputRef.current.value = '';
            }
        },
        [validateImage]
    );

    return (
        <FotosContainer>
            <FotosRow>
                {images.map((foto, index) => {
                    return <Foto key={index} index={index} item={foto} />;
                })}
                {images.length < 4 && (
                    <>
                        <PlusImage htmlFor="imageUpload" type="file">
                            <CameraAltOutlined sx={{ fontSize: 42, color: 'black' }} />
                            <ImageText>Adicionar Imagem</ImageText>
                        </PlusImage>

                        <InputImage
                            ref={imageInputRef}
                            onChange={onChangeImage}
                            type="file"
                            id="imageUpload"
                        />
                    </>
                )}
            </FotosRow>
        </FotosContainer>
    );
};
